<div #scrollContainer class="feed" *ngIf="(messages$ | async).length > 0" (mouseleave)="scrollToBottom()">
    <feed-message *ngFor="let message of messages$ | async" [message]="message"></feed-message>
</div>
